import React from "react";
import "./timePickerPopup.scss";
import { ARROW_TYPE } from "../../Constants";

const TimePickerPopup = (props) => {
  const {
    open,
    consultationType,
    start_hr,
    end_hr,
    start_min,
    end_min,
    isStartAM,
    isEndAM,
    errorMessage,
    hasError,
    handleStartAM,
    handleEndAM,
    handleHrChange,
    handleMnChange,
    handleEndHrChange,
    handleEndMnChange,
    handleUpDownArrow,
  } = props;

  // Display UI ===>

  const timeInputUI = (
    label,
    hour,
    minute,
    isAM,
    startOrEndTime,
    handleHourChange,
    handleMinuteChange,
    handleMeridiem
  ) => {
    return (
      <div className="time-picker-timer-container">
        <div className="time-picker-timer-label">{label}</div>
        <div className="time-picker-timer-ui">
          <div>
            <div
              className="icon-size"
              onClick={() =>
                handleUpDownArrow("hour", ARROW_TYPE.ARROW_UP, startOrEndTime)
              }
              style={{ height: "18px" }}
            >
              <i className="fa fa-angle-up"></i>
            </div>
            <input
              type="number"
              min="01"
              max="12"
              value={hour}
              onChange={handleHourChange}
            />
            <div
              className="icon-size"
              onClick={() =>
                handleUpDownArrow("hour", ARROW_TYPE.ARROW_DOWN, startOrEndTime)
              }
            >
              <i className="fa fa-angle-down"></i>
            </div>
          </div>
          <div className="time-picker-timer-separator">:</div>
          <div>
            <div
              className="icon-size"
              onClick={() =>
                handleUpDownArrow("minute", ARROW_TYPE.ARROW_UP, startOrEndTime)
              }
              style={{ height: "18px" }}
            >
              <i className="fa fa-angle-up"></i>
            </div>
            <input
              type="number"
              min="00"
              max="59"
              value={minute}
              onChange={handleMinuteChange}
            />
            <div
              className="icon-size"
              onClick={() =>
                handleUpDownArrow(
                  "minute",
                  ARROW_TYPE.ARROW_DOWN,
                  startOrEndTime
                )
              }
            >
              <i className="fa fa-angle-down"></i>
            </div>
          </div>
        </div>
        <div className="time-picker-timer-meridiem" onClick={handleMeridiem}>
          {isAM ? "AM" : "PM"}
        </div>
      </div>
    );
  };
  const getErrorUI = () => {
    let errorComponent;
    if (hasError) {
      errorComponent = <p className="slot-error">{errorMessage}</p>;
    } else {
      errorComponent = null;
    }
    return errorComponent;
  };

  // <===

  return (
    <>
      {open ? (
        <div className="time-picker-popup-container">
          <div className="timepicker-header">{consultationType.label}</div>
          {timeInputUI(
            "START TIME",
            start_hr,
            start_min,
            isStartAM,
            "start",
            handleHrChange,
            handleMnChange,
            handleStartAM
          )}
          {timeInputUI(
            "END TIME",
            end_hr,
            end_min,
            isEndAM,
            "end",
            handleEndHrChange,
            handleEndMnChange,
            handleEndAM
          )}
          {getErrorUI()}
        </div>
      ) : null}
    </>
  );
};
export default TimePickerPopup;
